export const shortTypes = {
  BU: 'BU',
  CO: 'CO',
  CN: 'CN',
  CC: 'CC',
  BZ: 'BZ',
  AL: 'AL',
  USR: 'USR',
};

export enum assignmentTypes {
  BUSINESS_UNITS = 'BU',
  COMPANY_CODES = 'CC',
  COUNTRIES = 'CO',
  CONNECTIONS = 'CN',
  BUSINESSES = 'BZ',
  ALL = 'AL',
  USER = 'USR',
}
